export default __webpack_public_path__ + "static/media/Rect2.5b5356fb.svg";